import { useContextState } from "../../../../../../hooks/theme"


export const useStyles = () => {
    const { colors } = useContextState()
    return {
        container: (expired:boolean) => ({
            display: 'flex',
            padding: '8px',
            alignItems: 'center',
            gap: '4px',
            borderRadius: '30px',
            maxWidth: '111px',
            backgroundColor:  expired ? `${colors.color12}55` : colors.color32,
            '& .MuiTypography-root':{
                color: expired ? colors.color19 : colors.color5,
                fontSize: '12px',
                fontWeight: 'bold'
            },
            '& .MuiSvgIcon-root':{
                color: expired ? colors.color19 : colors.color5,
                fontSize: '20px'
            }
        })
    }
}
